module.exports = __webpack_public_path__ + "/hashedassets-launcher/google_sync.be8b932d09b03aa134a53e114ac93091.svg";